import { Colors } from '../../consts/Colors.js';

export default class QcmFeedbackA2 extends Phaser.GameObjects.Container {
    constructor(scene, feedbackData, img, isRight) {
        super(scene, 0, 0, []);
        scene.add.existing(this);
        this.scene = scene;
        this.feedbackData = feedbackData;
        this.img = img;
        this.isRight = isRight;
        this.screenContainer = this.scene.add.container(1920, 0);
        this.add(this.screenContainer);
        this.scene.addSounds()

        // let ctnt = this.isRight ? "Tout à fait !" : "Eh non !"
        let ctnt = {
            text: this.isRight ? "Tout à fait !" : "Eh non !",
            config: { size: '36px', fontFamily: 'CenturyGothicBold', align: 'left', color: Colors.Text.TextOrange, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 1140 },
        }

        let t = this.isRight ? 'check' : 'croix'

        this.correction = this.scene.createTextElement(280, 362, ctnt);
        this.screenContainer.add(this.correction);
        this.illuCorrection = this.scene.add.image(250, 372, t).setOrigin(0.5);
        this.screenContainer.add(this.illuCorrection);


        this.repText = this.scene.createTextElement(600, 466, this.feedbackData);
        this.screenContainer.add(this.repText);

        this.illu = this.scene.add.image(348, 687, this.img).setOrigin(0.5);
        this.screenContainer.add(this.illu);

        this.scene.tweens.add({
            targets: this.screenContainer,
            x: 0,
            duration: 400,
            ease: 'Power2',
        })
        let soundName = this.isRight ? 'win' : 'lose'
        this.scene.playSound(soundName)
    }
}
